module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iI2M2MGMzMCIgZD0iTTAgMGg2NDAuMXY0ODBIMHoiLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjA1LjcxNCAwaDY4LjU3djQ4MGgtNjguNTd6Ii8+CiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTAgMjA1LjcxNGg2NDAuMXY2OC41N0gweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/dk.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/dk.svg
// module chunks = 0